export const radioCheckRegEx = /checkbox|radio/
export const routeQueryRegEx = /sellersinformation|menu|review/gi // Loosely check query string params
export const TOPIC_NAME = 'topic'
export const REASON_NAME = 'reason'
export const errorCodes = {
  alreadyReported: '208',
  notFound: '404',
  internalServerError: '500',
  serviceUnavailable: '503'
}

